import * as React from 'react';
import { Element } from 'react-scroll';
import Header from './Header';

interface IContainerProps {
  children: React.ReactNode;
}

export default function Container(props: IContainerProps) {
  const { children } = props;

  return (
    <div>
      <Element name="index" />
      <Header />
      {children}
    </div>
  );
}
